import { render, staticRenderFns } from "./Bando26Fase2.vue?vue&type=template&id=1a6b5e18&scoped=true"
import script from "./Bando26Fase2.vue?vue&type=script&lang=js"
export * from "./Bando26Fase2.vue?vue&type=script&lang=js"
import style0 from "./Bando26Fase2.vue?vue&type=style&index=0&id=1a6b5e18&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a6b5e18",
  null
  
)

export default component.exports